import type { PortalColorScale } from '../types';

export const hero: PortalColorScale = {
  100: '#EDEEF7',
  200: '#BABBCA',
  300: '#787B9A',
  400: '#49517D',
  500: '#2C3667',
  600: '#1F2647',
  700: '#1B2140',
  800: '#1C1D2B',
  900: '#010212',
};

export const blue: PortalColorScale = {
  100: '#EDF4FB',
  200: '#D2E4F4',
  300: '#99C1E6',
  400: '#589AD7',
  500: '#0065C1',
  600: '#01539E',
  700: '#01407A',
  800: '#012F59',
  900: '#011C36',
};

export const yellow: PortalColorScale = {
  100: '#FFFDF1',
  200: '#FEFAD5',
  300: '#FEF6B1',
  400: '#FDF07A',
  500: '#FCE838',
  600: '#D0BF2F',
  700: '#A49825',
  800: '#746B1A',
  900: '#464010',
};

export const red: PortalColorScale = {
  100: '#F8EEED',
  200: '#EBD1D0',
  300: '#D6A09E',
  400: '#BC6460',
  500: '#9E1E19',
  600: '#841915',
  700: '#661411',
  800: '#4B0F0C',
  900: '#2C0908',
};

export const green: PortalColorScale = {
  100: '#EDF5ED',
  200: '#CAE2CB',
  300: '#97C799',
  400: '#56A45A',
  500: '#007505',
  600: '#016005',
  700: '#014B04',
  800: '#013803',
  900: '#012002',
};

export const neutral: PortalColorScale = {
  100: '#F2F2F6',
  200: '#D9D9DB',
  300: '#B4B4B8',
  400: '#919196',
  500: '#63636A',
  600: '#4F4F57',
  700: '#30313A',
  800: '#232429',
  900: '#17181A',
};

export const black: string = '#000000';
export const white: string = '#FFFFFF';
